import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { Playlist } from '../../api/rootstech/playlist/playlist.types'
import { getPlaylists as getPlaylistsApi } from '../../api'

type UsePlaylists = Omit<UseQueryResult, 'data'> & { playlists: Playlist[] }

export const usePlaylists = (): UsePlaylists => {
  const { data: playlists = [], ...rest } = useQuery({
    queryKey: ['playlists'],
    queryFn: async () => getPlaylistsApi(),
    staleTime: Infinity,
    select: ({ data }) =>
      data.results.sort((a: Playlist, b: Playlist) => {
        if (a.default !== b.default) return a.default ? -1 : 1
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      }) as Playlist[],
  })
  return { playlists, ...rest }
}
